import { useMemo } from 'react';
import { useBookingAppConfiguration } from './useBookingAppConfiguration';
import { useHandoverProps } from './useHandoverProps';
export function useMileagePriceTag() {
  const {
    showLowMileageTag,
    showHighMileageTag,
    mileageTagThresholds
  } = useBookingAppConfiguration();
  const handoverProps = useHandoverProps();
  const carYear = handoverProps?.car?.builtYear;
  const carMileage = handoverProps?.car?.km;
  const carYearThreshold = mileageTagThresholds && mileageTagThresholds[carYear];
  const carYearThresholdLow = carYearThreshold?.low;
  const carYearThresholdHigh = carYearThreshold?.high;
  const lowMileageTagShown = showLowMileageTag && carMileage && carYearThresholdLow && carMileage < carYearThresholdLow;
  const highMileageTagShown = showHighMileageTag && carMileage && carYearThresholdHigh && carMileage > carYearThresholdHigh;
  return useMemo(() => {
    return {
      showLowMileageTag,
      showHighMileageTag,
      lowMileageTagShown,
      highMileageTagShown,
      carMileage,
      carYear,
      carYearThresholdLow,
      carYearThresholdHigh
    };
  }, [carMileage, carYear, carYearThresholdHigh, carYearThresholdLow, highMileageTagShown, lowMileageTagShown, showHighMileageTag, showLowMileageTag]);
}